<button
  mat-button
  (click)="reportIssue()"
>
  Message Us
</button>
